module.exports = __webpack_public_path__ + "static/media/abcattech.4dfb2503.png";